/* global $ */

const expandCollapse = require('../components/expand-collapse');
const mission = require('../components/join-block');
const technology = require('../components/technology-block');
const catalog = require('../components/catalog-block');
// const contact = require('../components/contact-block');

exports.init = function() {
    // Home page initialization.  $ is available here...

	initModule(expandCollapse);
	initModule(mission);
	initModule(technology);
	initModule(catalog);
	// initModule(contact);
};

function initModule(mod) {
	// console.log("initModule(): "+mod);
    if ((mod !== null) && (typeof mod !== 'undefined') && (typeof mod.init === 'function')) {
        mod.init();
    }
}